import { defineComponent, reactive } from 'vue'
import './index.scss'

export default defineComponent({
  name: 'TemplateUser',
  setup() {
    const state = reactive({
      cardBodyStyle: {
        width: 600
      }
    })
    return () => (
      <div class="user-page page-container">
        <n-card class="page-content" bordered={false} style={state.cardBodyStyle}>
          <router-view></router-view>
        </n-card>
      </div>
    )
  }
})
